@if (_context) {
    <mat-tab-group class="detail-tabs">
        <mat-tab label="Infos">
            <app-user-form
                [disabled]="_context.formMode === FormMode.Reading"
                [context]="_context.userContext"
                [user]="_context.userContext.item"
                [isProfile]="false"
                (userUpdated)="onUserUpdated($event)"
                (canceled)="onCanceled($event)"></app-user-form>
        </mat-tab>
        @if (!!_context.userContext.item.id) {
            <!-- <mat-tab label="Accessibilité bannettes">
                <app-user-accessibility
                    [user]="_context.userContext.item"
                    [disabled]="_context.formMode === FormMode.Reading"
                    (accessibilitiesUpdated)="onAccessibilitiesUpdated($event)"
                    (canceled)="onCanceled($event)"></app-user-accessibility>
            </mat-tab> -->
            <mat-tab label="Accessibilité vues">
                <app-user-views-accessibility
                    [user]="_context.userContext.item"
                    [disabled]="_context.formMode === FormMode.Reading"
                    (viewsAccessibilitiesUpdated)="onViewsAccessibilitiesUpdated($event)"
                    (canceled)="onCanceled($event)"></app-user-views-accessibility>
            </mat-tab>
        }
        @if (!!_context.paramsContext.paramsValues) {
            <mat-tab label="Paramètres">
                <app-parameters-values-form
                    [disabled]="_context.formMode === FormMode.Reading"
                    [context]="_context.paramsContext"
                    [paramsValues]="_context.paramsContext.paramsValues"
                    [hierarchyValues]="_context.paramsContext.groupParentParamsValues"
                    (paramsValuesUpdated)="onParamsValuesUpdated($event)"
                    (paramsExported)="onParamsExported()"
                    (canceled)="onCanceled($event)"></app-parameters-values-form>
            </mat-tab>
        }
        @if (!!_context.userContext.item.id) {
            <mat-tab label="Groupes parents">
                <app-group-parent-form [context]="_context.userContext">[readOnly]="true"</app-group-parent-form>
            </mat-tab>
        }
    </mat-tab-group>
}
